export const columns = function() {
  return [
    {
      prop: 'create_time',
      label: '创建时间',
      sortable: true,
    },
    {
      prop: 'rules',
      label: 'rules',
      link: true,
    },
    {
      prop: 'custom',
      label: '自定义',
      link: true,
      custonSlotName: 'custom'
    },
    {
      prop: 'handle',
      label: '操作',
    }
  ]
} 

export default {}